import useFormatter from "@/hooks/use-formatter.hook.ts";
import usePermissions from "@/hooks/use-permissions.hook.ts";
import {
  usePeopleAnalyticsCacheState,
  useRebuildPeopleAnalyticsCache,
} from "@/queries/reporting/use-people-analytics.query.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { Button, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export const PeopleAnalyticsCacheStatus = () => {
  const { t } = useTranslation();
  const { canIEdit } = usePermissions();
  const { renderDateAndTime } = useFormatter();
  const cacheState = usePeopleAnalyticsCacheState();
  const rebuildCache = useRebuildPeopleAnalyticsCache();

  if (!cacheState.data) return null;
  const builtAt = cacheState.data.datetime_built;

  return (
    <Stack direction="horizontal" gap="sm" items="center">
      <Text size="sm" className="text-secondary whitespace-nowrap">
        {builtAt
          ? t("reporting:people_analytics_cache_built_at", { date: renderDateAndTime(builtAt) })
          : t("reporting:people_analytics_cache_live")}
      </Text>
      {canIEdit(ApiPermission.reporting_people_analytics) && (
        <Button
          variant="secondary"
          isLoading={rebuildCache.isPending}
          onClick={() => rebuildCache.mutate()}
        >
          {t("reporting:people_analytics_cache_rebuild")}
        </Button>
      )}
    </Stack>
  );
};
